/**
 * Снятие баннера входящего звонка в браузере.
 *
 * <p>Пушем это сделать нельзя: браузер требует, чтобы каждое доставленное сообщение что-нибудь
 * показало, и «тихое закрытие» превращается в служебное «сайт обновлён в фоновом режиме».
 * Поэтому баннер снимает та сторона, которая и так знает правду о звонке, — открытая вкладка,
 * по вебсокетному кадру. Для закрытого браузера остаётся серверное вытеснение: сообщение
 * `CALL_DISMISS` заменяет ринг тихой строкой под той же меткой (см. `firebase-messaging-sw.js`).
 *
 * <p>Метка совпадает с той, что ставит service worker: `call_<callId>`.
 */
export const closeWebCallNotification = (callId: string): void => {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }
  navigator.serviceWorker.ready
    .then((registration) => registration.getNotifications({ tag: `call_${callId}` }))
    .then((notifications) => {
      notifications.forEach((notification) => notification.close());
      return undefined;
    })
    .catch(() => undefined);
};
